import React from 'react'
import Button from '@material-ui/core/Button'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import Grow from '@material-ui/core/Grow'
import Paper from '@material-ui/core/Paper'
import Popper from '@material-ui/core/Popper'
import MenuItem from '@material-ui/core/MenuItem'
import MenuList from '@material-ui/core/MenuList'
import { makeStyles } from '@material-ui/core/styles'
import DownloadIcon from '../../src/assets/images/icons/download.svg'
import CustomImage from './CustomImage'
import { GiDivert } from 'react-icons/gi'
import { Typography } from '@material-ui/core'
import { CSVLink } from 'react-csv'
import jsPDF from 'jspdf'
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  paper: {
    marginRight: theme.spacing(2),
  },
  hover: {
    cursor: 'pointer',
  },
  left: {
    left: '-16px',
    // top: '4px',
  },
}))

export default function CustomDrop({ className, data, heading, headers, filename, downloadLoading }) {
  const classes = useStyles()
  const [open, setOpen] = React.useState(false)
  const anchorRef = React.useRef(null)

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen)
  }

  const handleClose = (event) => {
    // if (anchorRef.current && anchorRef.current.contains(event.target)) {
    //   return
    // }

    setOpen(false)
  }

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault()
      setOpen(false)
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open)
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus()
    }

    prevOpen.current = open
  }, [open])

  console.log({ headers, data })

  const csvReport = {
    data: data,
    headers: headers,
    filename: filename
      ? filename + '.csv'
      : heading === 'Leave Requests'
      ? 'leave_requests.csv'
      : // : heading === 'Manage Employees'
      // ? 'employees.csv'
      heading === 'Lead Management'
      ? 'leads.csv'
      : heading === 'Beat Plan Requests'
      ? 'beats.csv' :// : heading === 'Manage Categories'
        // ? 'categoryMaster.csv'
        // : heading === 'Manage SubCategory'
        // ? 'subcategoryMaster.csv'
        // : heading === 'Manage Products'
        // ? 'productMaster.csv'
        // heading === 'Manage Targets'
        // ? 'target.csv'
        // : // : heading === 'Manage Regions'
        // ? 'region.csv'
        // heading === 'Manage Zone'
        // ? 'zone.csv'
        // : heading === 'Manage State'
        // ? 'state.csv'
        // : heading === 'Manage District'
        // ? 'district.csv'
        // : heading === 'Manage City'
        // ? 'city.csv'
        // : heading === 'Manage Area'
        // ? 'area.csv'
        // : heading === 'Manage Store'
        // ? 'store.csv'

        null,
  }

  console.log({csvReport, downloadLoading})

  const exportPDF = () => {
    const unit = 'pt'
    const size = 'A4' // Use A1, A2, A3 or A4
    const orientation = 'landscape' // portrait or landscape
    const marginLeft = 20
    const doc = new jsPDF(orientation, unit, size)

    doc.setFontSize(15)

    const title = heading
    const categoryHeaders = [['Name', 'Description']]
    const SubCategoryheaders = [['Name', 'Category Name', 'Description']]
    const categoryData = data.map((item) => [item.categoryName, item.description])
    const attendanceHeaders = [['Name', 'Position', 'In Time', 'Check Out Time', 'Location', 'Last Modified By', 'Status']]
    const leaveHeaders = [['Name', 'Position', 'From', 'To', 'Total Days', 'Type', 'Action Taken By', 'Status']]
    const employeeHeader = [['Name', 'Employee Type', 'Phone Number', 'Email', 'Joining Date', 'Position', 'Reporting Manager', 'active']]
    const leadHeader = [['Name', 'Agent', 'Lead Type', 'Age', 'Status', 'Follow Up']]
    const productHeader = [['Name', 'Category', 'SubCategory', 'Color', 'SKU', 'Distributor Price', 'Dealer Price', 'Stock Left']]
    const targetHeader = [['Target Name', 'Target Type', 'Template Category', 'From', 'To', 'Target For', 'Channel Type', 'Target Based On']]
    // const regionHeader = [['name', '_id', 'companyAdminId', 'regionCode']]
    const zoneHeader = [['regionName', 'region', 'companyAdminId', 'regionCode', 'zoneName', 'zone', 'zoneCode']]
    const stateHeader = [['regionName', 'region', 'companyAdminId', 'regionCode', 'zoneName', 'zone', 'zoneCode', 'stateName', 'stateCode']]

    const pdfHeader = [headers.map((item) => item.label)]

    const attendanceData = data.map((item) => [item.name, item.position, item.inTime, item.checkOutTime, item.location, item.lastModifiedBy, item.status])
    const leaveData = data.map((item) => [item.name, item.position, item.leaveFrom, item.leaveTo, item.totalDays, item.type, item.actionBy, item.status])
    const employeeData = data.map((item) => [item.name, item.type, item.phoneNumber, item.email, item.joiningDate, item.position, item.reportingManager, item.active])
    const leadData = data.map((item) => [item.name, item.agent, item.type, item.age, item.status, item.followupdate])

    const tempSubCategoryData = data.map((item) => [item.subcategoryName, item.categoryName, item.description])
    const productData = data.map((item) => [item.name, item.category, item.subcategory, item.color, item.sku, item.distributorPrice, item.dealerPrice, item.stockLeft])
    const targetData = data.map((item) => [item.targetName, item.targetType, item.templateCategory, item.targetFrom, item.targetTo, item.targetFor, item.channelType, item.targetBasedOn])
    // const regionData = data.map((item) => [item.name, item.id, item.companyAdminId, item.regionCode])
    const zoneData = data.map((item) => [item.zoneName, item.zone, item.zoneCode, item.companyAdminId, item.regionCode, item.regionName, item.region])
    const stateData = data.map((item) => [item.zoneName, item.zone, item.zoneCode, item.companyAdminId, item.regionCode, item.regionName, item.region, item.stateName, item.stateCode])

    const pdfData = data.map((item) => Object.values(item))

    let content = {
      startY: 50,
      head:
        // heading === 'Manage SubCategory'
        //   ? SubCategoryheaders
        //   :
        heading === 'Leave Requests'
          ? leaveHeaders
          : // : heading === 'Manage Employees'
            // ? employeeHeader
            // : heading === 'Lead Management'
            // ? leadHeader
            // : heading === 'Manage Categories'
            // ? categoryHeaders
            // : heading === 'Manage Products'
            // ? productHeader
            // heading === 'Manage Targets'
            // ? targetHeader
            // : // : heading === 'Manage Regions'
            // ? regionHeader
            // heading === 'Manage Zone'
            // ? zoneHeader
            // : heading === 'Manage State'
            // ? stateHeader
            pdfHeader,
      body:
        // heading === 'Manage SubCategorys'
        //   ? tempSubCategoryData
        //   :
        heading === 'Leave Requests'
          ? leaveData
          : // : heading === 'Manage Employees'
            // ? employeeData
            // : heading === 'Lead Management'
            // ? leadData
            // : heading === 'Manage Categories'
            // ? categoryData
            // : heading === 'Manage Products'
            // // ? productData
            // heading === 'Manage Targets'
            // ? targetData
            // : // : heading === 'Manage Regions'
            // ? regionData
            // heading === 'Manage Zone'
            // ? zoneData
            // : heading === 'Manage State'
            // ? stateData
            pdfData,
    }

    doc.text(title, marginLeft, 40)
    doc.autoTable(content)
    doc.save(
      filename
        ? filename + '.pdf'
        : // : heading === 'Manage SubCategory'
        // ? 'subcategory.pdf'
        // : heading === 'Manage Employees'
        // ? 'employees.pdf'
        heading === 'Leave Requests'
        ? 'leave_requests.pdf'
        : // : heading === 'Lead Management'
          // ? 'leads.pdf'
          // : heading === 'Manage Products'
          // ? 'products.pdf'
          // : heading === 'Manage Regions'
          // ? 'target.pdf'
          // heading === 'Manage Targets'
          // ? 'region.pdf'
          // : // : heading === 'Manage Zone'
          // ? 'zone.pdf'
          // : heading === 'Manage State'
          // ? 'state.pdf'
          'report.pdf'
    )
    handleClose()
  }

  return (
    <div style={{ zIndex: 100 }}>
      <div ref={anchorRef} aria-controls={open ? 'menu-list-grow' : undefined} aria-haspopup="true" onClick={handleToggle} className={className} style={{ marginTop: '14px' }}>
        <CustomImage image={DownloadIcon} />
      </div>
      <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal className={classes.left}>
        {({ TransitionProps, placement }) => (
          <Grow {...TransitionProps} style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom', left: '-16px' }}>
            <Paper style={{ padding: '10px' }}>
              <Typography style={{ fontWeight: 600 }}>Download</Typography>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                  <MenuItem disabled={downloadLoading} onClick={handleClose}>
                    <CSVLink {...csvReport} style={{ textDecoration: 'none', color: 'black' }}>
                      CSV
                    </CSVLink>
                  </MenuItem>
                  {/* <MenuItem onClick={handleClose}>XLS</MenuItem> */}
                  <MenuItem disabled={downloadLoading} onClick={exportPDF}>
                    PDF
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  )
}
